import { Builder } from '@builder.io/react'
import GenericRichText from './genericRichText'

Builder.registerComponent(GenericRichText, {
  name: 'Rich Text',
  inputs: [{ name: 'text', type: 'richText', defaultValue: '<p>Body text here...</p>' }],
})
